import React from 'react';
import { ProgressInnerText } from './ProgressInnerText';
import { ProgressStackItem } from './ProgressStackItem';
import { progressBlock } from './constants';
import { getOffset, getValueFromStack } from './utils';
export function ProgressWithStack(props) {
    const { stack, stackClassName, value, text } = props;
    const offset = getOffset(value || getValueFromStack(stack));
    return (React.createElement("div", { className: progressBlock('stack', stackClassName), style: { transform: `translateX(calc(var(--g-flow-direction) * ${offset}%))` } },
        React.createElement("div", { className: progressBlock('item'), style: { width: `${-offset}%` } }),
        stack.map((item, index) => (React.createElement(ProgressStackItem, { key: index, item: item }))),
        React.createElement(ProgressInnerText, { offset: offset, text: text })));
}
